<template>
  <v-toolbar :color="hasSelectedLotes ? 'rgba(17, 138, 202, 0.1)' : undefined" elevation="0" dense>
    <v-checkbox
      @change="handleCheckboxClick"
      :value="selectedAll"
      :indeterminate="indeterminate"
      :disabled="disabled"
      :label="label"
      hide-details
    />
    <div v-if="hasSelectedLotes" class="primary--text">{{ selectedLotes | pluralize }}  de {{ totalLotes }}</div>
    <v-spacer />
    <div>
      <v-menu offset-x offset-y left nudge-right="100">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            v-bind="attrs"
            v-on="on"
            outlined
          >
            Opções
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            @click="item.onClick"
            :key="index"
            :disabled="item.disabled"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    selectedLotes: Array,
    totalLotes: Number
  },
  data () {
    return {

    }
  },
  computed: {
    hasSelectedLotes () {
      return this.selectedLotes.length > 0
    },
    selectedAll () {
      return this.selectedLotes.length > 0 && this.selectedLotes.length === this.totalLotes
    },
    indeterminate () {
      return this.selectedLotes.length > 0 && this.selectedLotes.length < this.totalLotes
    },
    disabled () {
      return this.totalLotes === 0
    },
    label () {
      return this.selectedLotes.length === 0 ? 'Selecionar todas as guias' : undefined
    },
    items () {
      return [
        {
          title: 'Executar conciliação automática',
          onClick: () => this.modalConciliacaoAutomatica(),
          disabled: this.isActionDisabled("ConciliarAutomaticamente")
        },
        {
          title: 'Deletar toda conciliação',
          onClick: () => this.modalDeletaConciliacao(),
          disabled: this.isActionDisabled("Desconciliar")
        },
        {
          title: 'Iniciar conciliação manual',
          onClick: this.handleConciliacaoManual,
          disabled: this.isActionDisabled("ConciliarManualmente")
        },
        {
          title: 'Assumir lotes',
          onClick: this.handleAssumirLotes,
          disabled: this.isActionDisabled("AssumirComoResponsavel")
        },
        {
          title: 'Limpar responsável',
          onClick: this.handleLimparResponsavel,
          disabled: this.isActionDisabled("RemoverResponsavel")
        },
        {
          title: 'Finalizar conciliação',
          onClick: this.handleFinalizarConciliacao,
          disabled: this.isActionDisabled("FinalizarConciliacaoManual")
        }
      ]
    }
  },
  methods: {
    modalConciliacaoAutomatica () {
      const paramModal = {
        type: "warning",
        title: "Conciliação automática",
        message: "Os lotes selecionados serão enviados para conciliação automática e todas as guias e itens conciliados serão desconciliados.",
        callback: this.handleConciliacaoAutomatica,
        btConfirm: { name: "Confirmar", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    modalDeletaConciliacao () {
      const paramModal = {
        type: "warning",
        title: "Deletar conciliação",
        message: "Essa ação desassocia todas as guias e desconcilia todos os itens do(s) lote(s) selecionado(s).",
        callback: this.handleDesconciliar,
        btConfirm: { name: "Confirmar", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    handleConciliacaoAutomatica () {
      return this.$emit('conciliacaoAutomatica')
    },
    handleDesconciliar () {
      return this.$emit('desconciliar')
    },
    handleConciliacaoManual () {
      return this.$emit('conciliacaoManual')
    },
    handleAssumirLotes () {
      return this.$emit('assumirLotes')
    },
    handleLimparResponsavel () {
      return this.$emit('limparResponsavel')
    },
    handleFinalizarConciliacao () {
      return this.$emit('finalizarConciliacao')
    },
    handleCheckboxClick (checked) {
      if (checked) {
        this.$emit('selectAllLotes')
      } else {
        this.$emit('deselectAllLotes')
      }
    },
    isActionDisabled (action) {
      return this.selectedLotes.some(lote => !lote.acoes.includes(action))
    }
  },
  filters: {
    pluralize (array) {
      const count = array.length
      if (count === 0) {
        return 'Nenhum lote selecionado'
      } else if (count === 1) {
        return '1 lote selecionado'
      } else {
        return `${count} lotes selecionados`
      }
    }
  }
}
</script>

<style scoped>
.items-text {
  color: #118ACA
}
.opcoes-container {
  background-color: rgba(17, 138, 202, 0.1);;
}
</style>
